import type { z } from 'zod';
import {
  markerFilterDefaultValue,
  markerFilterSchema
} from 'pages/marking/schemas/shared-filter-form.schema';

export const filterFormSchema = markerFilterSchema;

export type FilterFormValues = z.infer<typeof filterFormSchema>;

export const filterFormDefaultValues: FilterFormValues = markerFilterDefaultValue;
